import http from "../../../../../../../core/utils/apis/skillApi";

const BASE = "/evaluation-skill-requests";

export const EvaluationSkillRequestService = {
  getBySubmissionAndUser: (submissionId, userId) =>
    http
      .get(`${BASE}/submission/${submissionId}/user/${userId}`)
      .then((res) => res.data),
};
export const approveEvaluationSkillRequest = async (id, validatedBy) => {
  const res = await http.put(`/evaluation-skill-requests/${id}/approve`, {
    validatedBy,
  });
  return res.data;
};

export const rejectEvaluationSkillRequest = async (id, validatedBy) => {
  const res = await http.put(`/evaluation-skill-requests/${id}/reject`, {
    validatedBy,
  });
  return res.data;
};